import { API, graphqlOperation } from 'aws-amplify'
import { createVacancyReaction, deleteVacancyReaction } from '@/graphql/mutations'

async function post(url, contactModel) {
  const response = await API.post('romatchcontactapi', url, {
    body: contactModel,
  })
  console.log(response) // debug
}

export default {
  async storeVacancyReaction(reaction) {
    await API.graphql(graphqlOperation(createVacancyReaction, { input: reaction }))
  },
  async deleteVacancyReaction(vacancyReactionId) {
    await API.graphql(
      graphqlOperation(deleteVacancyReaction, {
        input: {
          id: vacancyReactionId,
        },
      })
    )
  },
  async sendReaction(reaction) {
    return await post('/vacancyresponse', reaction)
  },
  async sendContactForm(contactModel) {
    return await post('/contact', contactModel)
  },
}
